import {SUPPORT_EVENTS} from '../consts';

const supportEvents = new Set<string>(SUPPORT_EVENTS);

export function supportEvent(eventName: string) {
  return supportEvents.has(eventName);
}
